import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { L1TimeSeriesEdit } from "./edit";
import { L1TimeSeriesNew } from "./new";
import { L1TimeSeriesTable } from "./table";

export default function L1TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<L1TimeSeriesEdit />} />
      <Route index element={<L1TimeSeriesTable />} />
      <Route path="/new" element={<L1TimeSeriesNew />} />
    </Routes>
  );
}
